import { createGlobalStyle } from 'styled-components/macro';

const GlobalStyles = createGlobalStyle`
*,
            *::before,
            *::after {
            box-sizing: border-box;
          }

            html, body {
            height: 100vh;
            background-color: #ffffff;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            /* hidden causes problem with scrollListener */
            /* overflow-x: hidden;  */
            text-rendering: optimizeLegibility;
            /* font-family: miller-display, serif;
            font-weight: 600;
            font-style: italic; */
          }

html {
  /* no problems with scrollListener setting it for html only*/
  /* this way, no little horizontal scroll on mobile*/
            overflow-x: hidden;
          }
          
body {
  min-height: 100vh;
  -webkit-overflow-scrolling: touch;
  }
  
 /****** Elad Shechter's RESET *******/ 
a{text-decoration:none; color:inherit; cursor:pointer; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); -webkit-tap-highlight-color: transparent;}
button{background-color:transparent; color:inherit; border-width:0; padding:0; cursor:pointer;}
figure{margin:0;}
input::-moz-focus-inner {border:0; padding:0; margin:0;}
ul, ol, dd{margin:0; padding:0; list-style:none;}
h1, h2, h3, h4, h5, h6{margin:0; font-size:inherit; font-weight:inherit;}
p{margin:0;}
cite {font-style:normal;}
fieldset{border-width:0; padding:0; margin:0;}


/* @font-face {
  font-family: 'Tiempos';
  font-style: normal;
  font-weight: 900;    
  src: url(${'./Fonts/TiemposHeadline-Black.woff'}) format("font-woff");
  } */

  
`;

export default GlobalStyles;
